import React from "react"
import News from "../components/News"

const NewsPage = () => {
  return (
    <>
      <News />
    </>
  )
}

export default NewsPage
